import { BorderRadius } from '../../tokens/borderRadius';
import { COLORS } from '../../tokens/colors';

const common = {
    style: {
        boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.24)',
        borderRadius: BorderRadius.labelRadius,
        minWidth: '28px',
        minHeight: '28px',
        padding: '8px 12px',
        display: 'block',
        transition: 'opacity .3s ease-in-out, visibility .3s ease-in-out',
    },
    arrowStyle: {
        borderColor: false,
        transition: false,
    },
};

const defaultTheme = {
    light: {
        style: {
            ...common.style,
            background: COLORS.BgMain,
            color: COLORS.TextPrimary,
        },
        arrowStyle: {
            ...common.arrowStyle,
            color: COLORS.BgMain,
        },
    },
    dark: {
        style: {
            ...common.style,
            background: COLORS.ButtonPrimary,
            color: COLORS.TextWhite,
        },
        arrowStyle: {
            ...common.arrowStyle,
            color: COLORS.ButtonPrimary,
        },
    },
};

export default defaultTheme;
